import { AuthProvider, LoginScreen, useAuth } from "@ozpanel/ui";
import * as React from "react";
import { MailboxApp } from "./MailboxShell";
import { PairScreen, readPairLink } from "./PairScreen";

function Gate() {
  const { who, loading } = useAuth();
  // A phone-setup link (#pair?token=…) is spent before anything decides who is signed in: it signs this
  // device in as the mailbox, whoever (if anyone) it was signed in as before.
  const [pairToken, setPairToken] = React.useState(() => readPairLink());
  const donePairing = React.useCallback(() => setPairToken(null), []);
  if (pairToken) {
    return <PairScreen token={pairToken} onDone={donePairing} />;
  }
  if (loading) {
    return <div className="flex min-h-dvh items-center justify-center text-[13px] text-muted">Loading…</div>;
  }
  return who ? <MailboxApp /> : <LoginScreen title="Sign in to your mailbox" />;
}

export function App() {
  return (
    <AuthProvider>
      <Gate />
    </AuthProvider>
  );
}
